<template>
  <div id="declarationForm-wrapper">
    <mt-header
      fixed
      title="闭水验收服务留资页"
      class="header-wrapper"
    ></mt-header>

    <div class="banner">
      <img class="" src="../../static/images/banner.png" />
    </div>

    <div class="form">
      <mt-cell title="业主姓名">
        <span class="form-icon" slot="icon"
          ><img src="../../static/images/icon/icon-name.png" alt=""
        /></span>
        <input
          type="text"
          style="width: 45vw;"
          v-model="form.userName"
          placeholder="请输入业主姓名"
        />
      </mt-cell>
      <mt-cell title="业主手机号">
        <span class="form-icon" slot="icon"
          ><img src="../../static/images/icon/icon-tel.png" alt=""
        /></span>
        <input
          type="number"
          v-model="form.phone"
          placeholder="请输入业主手机号"
        />
      </mt-cell>
      <mt-cell title="工长姓名">
        <span class="form-icon" slot="icon"
          ><img src="../../static/images/icon/icon-name.png" alt=""
        /></span>
        <input
          type="text"
          v-model="form.workerName"
          placeholder="请输入工长姓名"
        />
      </mt-cell>

      <mt-cell title="工长手机号">
        <span class="form-icon" slot="icon"
          ><img src="../../static/images/icon/icon-tel.png" alt=""
        /></span>
        <input
          type="number"
          v-model="form.workerPhone"
          placeholder="请输入工长手机号"
        />
      </mt-cell>

      <!-- <div @click="depthSheetVisible=true"> -->
      <mt-cell title="深度(cm)">
        <span class="form-icon" slot="icon"
          ><img src="../../static/images/icon/icon-height.png" alt=""
        /></span>
        <input
          type="number"
          v-model="form.depth"
          placeholder="请输入闭水水位高度（cm）"
        />
        <!-- <span style="font-size: 3.5vw;">{{ form.depth ? form.depth+'cm' : '请选择深度'}}</span> -->
      </mt-cell>
      <!-- </div> -->

      <!-- 深度弹窗 -->
      <!-- <mt-popup
        @touchmove.native.stop.prevent
        v-model="depthSheetVisible"
        position="bottom"
        style="width:100%"
      >
        <mt-picker
          :slots="depthList"
          @change="ondepthListChange($event)"
          :show-toolbar="true"
          value-key="text"
        >
          <div class="depth-picker-title">
            <div @click="depthSheetVisible=false">取消</div>
            <div style="color:#03A2E4;" @click="depthConfirm">确认</div>
          </div>
        </mt-picker>
      </mt-popup>-->

      <!-- <mt-cell title="项目申请总面积（平米）">
        <input type="text" placeholder="请输入面积" />
      </mt-cell>-->
      <!-- <mt-cell title="扫码数量（桶）">
        <input type="text" placeholder="请输入数量" />
      </mt-cell>-->

      <!-- <mt-cell title="闭水开始时间">
        <input type="text" placeholder="请输入时间" />
      </mt-cell>
      <mt-cell title="预计验收时间">
        <input type="text" placeholder="请输入时间" />
      </mt-cell>-->

      <!-- <mt-cell title="了解途径">
        <input type="text" placeholder="请输入" />
      </mt-cell>-->

      <div class="item-group c_m_b_10 bg_white" @click="addrClick">
        <div class="item-title c_nowrap">
          <span class="form-icon"
            ><img src="../../static/images/icon/icon-address.png" alt=""
          /></span>
          所在区域
        </div>
        <div class="item-content">
          <span class="item-value c_no_pointer c_nowrap">
            {{
              (province == city
                ? province + district
                : province + city + district) || "请选择所在区域"
            }}
            <input type="hidden" placeholder="请选择省" v-model="province" />
            <input type="hidden" placeholder="请选择市" v-model="city" />
            <input type="hidden" placeholder="请选择区" v-model="district" />
          </span>
        </div>
      </div>

      <mt-cell title="详细地址">
        <span class="form-icon" slot="icon"
          ><img src="../../static/images/icon/icon-search.png" alt=""
        /></span>
        <input type="text" v-model="form.site" placeholder="请输入详细信息" />
      </mt-cell>
    </div>
    <div class="">
      <mt-cell title="上传图片" style="margin-bottom:0.5vw"></mt-cell>
      <div class="procedure">
        <div class="upImg-wrapper-item">
          <div
            class="c_rela procedure-img"
            v-for="(n, index) in upImgUrlList"
            :key="index"
          >
            <div class="imgdel" @click="delClick(index)">×</div>
            <img
              :src="qiniu + n + '?imageView2/1/w/100/h/100'"
              :data-src="qiniu + n"
              @click="imgShowClick"
              class
            />
          </div>
          <update-file
            @fileChange="getUrl($event)"
            v-show="upImgUrlList.length < 3"
          ></update-file>
        </div>
      </div>

      <mt-cell title="图片示例" style="margin-bottom:0.5vw"></mt-cell>
      <div class="sample-content">
        <div>
          <div
            style="font-size:'10vw;margin-bottom:2vw;width:100%;text-align:center"
          >
            水位刻度标识
          </div>
          <div class="sample-wrapper">
            <img
              @click="imgShowClick"
              :data-src="require('../assets/images/closedWaterSample1.jpg')"
              :src="require('../assets/images/closedWaterSample1.jpg')"
              alt
            />
          </div>
        </div>
        <div>
          <div
            style="font-size:'10vw;margin-bottom:2vw;width:100%;text-align:center"
          >
            蓄水后的全景
          </div>
          <div class="sample-wrapper">
            <img
              @click="imgShowClick"
              :data-src="require('../assets/images/closedWaterSample2.jpg')"
              :src="require('../assets/images/closedWaterSample2.jpg')"
              alt
            />
          </div>
        </div>
      </div>

      <!-- http://dmzoss.iyuhong.com.cn/3177874133408631508?imageView2/1/w/500/h/500 -->

      <!-- <mt-cell title="上传视频" style="margin-bottom:0.5vw"></mt-cell>
      <div class="uploadVideo-content">
        <div v-if="!videoUrl" class="upVideo-wrapper">
          <img :src="require('../assets/images/add.png')" alt />
          <input class="upVideo" type="file" @change="videoChange($event)" accept="video/*" />
        </div>
        <video
          v-if="!!videoUrl"
          width="100%"
          controls
          :src="qiniu+videoUrl"
          preload="auto"
          webkit-playsinline="true"
          playsinline="true"
          x-webkit-airplay="allow"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x5-video-orientation="portraint"
          style="object-fit:fill"
        ></video>
      </div>-->

      <!-- <div class="procedure">
        <div class="upImg-wrapper-item">
          <div class="c_rela procedure-img" v-for="(n,index) in upImgUrlList" :key="index">
            <div class="imgdel" @click="delClick(index)">×</div>
            <img
              :src="qiniu+n+'?imageView2/1/w/100/h/100'"
              :data-src="qiniu+n"
              @click="imgShowClick"
              class
            />
          </div>
          <update-file @fileChange="getUrl($event)" v-show="upImgUrlList.length<3"></update-file>
        </div>
      </div>-->

      <mt-cell title="备注" style="margin-bottom:0.5vw"></mt-cell>
      <mt-field
        style="height: 96px;font-size: 3.5vw;border:none;font-size: 3.5vw;"
        placeholder="请输入备注"
        type="textarea"
        v-model="form.remark"
      ></mt-field>
    </div>
    <footer>
      <mt-button style="background:#03A2E4" type="primary" @click="submitBtn"
        >提交</mt-button
      >
    </footer>

    <!--所在区域弹窗-->
    <div class="model_addr" v-show="addr.isShow">
      <div class="model-bg" @click="saveAddrClick"></div>
      <div class="model-body">
        <div class="model-header c_flex c_flex_between c_item_center">
          <div class="model-title">城市地区选择</div>
          <div class="model-cancel" @click="saveAddrClick(true)">×</div>
        </div>
        <div class="model-hot">
          <div class="model-hot-title">热门省市</div>
          <div class="model-hot-list c_flex">
            <div
              class="model-hot-group"
              v-for="(item, index) in addr.hotList"
              :key="index"
              :class="
                addr.province == item.province && addr.city == item.city
                  ? 'bg_red'
                  : ''
              "
            >
              <div
                class="model-item c_flex c_flex_center"
                @click="hotClick(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="model-choose">
          <div class="model-hot-title">省市区选择</div>
          <div class="model-choose-title c_flex">
            <div
              :class="addr.province ? '' : 'c_red'"
              @click="chooseAddress('province')"
            >
              {{ addr.province || "请选择" }}
            </div>
            <div
              v-show="addr.province"
              :class="addr.city ? '' : 'c_red'"
              @click="chooseAddress('city')"
            >
              {{ addr.city || "请选择" }}
            </div>
            <div
              v-show="addr.province && addr.city"
              :class="addr.district ? '' : 'c_red'"
              @click="chooseAddress('district')"
            >
              {{ addr.district || "请选择" }}
            </div>
          </div>
          <div class="model-choose-list" id="subList">
            <div
              class="model-choose-group"
              :class="index % 2 == 0 ? 'bg-fcfcfc' : 'bg_white'"
              v-for="(item, index) in addr.chooseList"
              :key="index"
            >
              <div
                class="model-item"
                :class="
                  addr.chooseType == 'province'
                    ? item.name == addr.province
                      ? 'c_red'
                      : ''
                    : addr.chooseType == 'city'
                    ? item.name == addr.city
                      ? 'c_red'
                      : ''
                    : addr.district == item.name
                    ? 'c_red'
                    : ''
                "
                @click="chooseClick(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--图片显示-->
    <c-imgshow
      @part_close="part_close"
      :ispart_imgshow="ispart_imgshow"
      :imgshow_url="imgshow_url"
    ></c-imgshow>

    <!--提交成功弹框-->
    <div class="confirmAlertBg " :class="isConfirmAlert ? '' : 'c_hide'"></div>
    <div class="confirmAlert" :class="isConfirmAlert ? '' : 'c_hide'">
      <div class="close">
        <img class="c-img" src="../../static/images/icon/icon-del.png" alt="" />
      </div>
      <div class="bg">
        <img class="" src="../../static/images/icon/icon-10.png" alt="" />
      </div>
      <div class="content">
        <div class="c_center c_blue c_size_16 c_m_t_5">雨虹闭水服务</div>
        <div class="c_center c_blue c_size_24 c_m_t_5 c_bold">十年质保</div>
        <div class="c_center c_blue c_size_16 c_m_t_5">400-770-8966</div>
        <div class="c_center c_size_20 c_m_t_5 c_bold">恭喜您提交成功!</div>
      </div>
      <div class="btn c_center">
        <div class="back">返回公众号</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Toast, Indicator, Popup, Picker, MessageBox } from "mint-ui";
//引入 省市区
let addressList = require("../comm/addressList.js");
import UpdateFile from "./update-file";
import CImgshow from "./c-imgshow";
const handler = function(e) {
  e.preventDefault();
};
export default {
  components: {
    UpdateFile,
    CImgshow
  },
  data() {
    return {
      form: {
        userName: "",
        phone: "",
        workerName: "",
        workerPhone: "",
        site: "",
        remark: "",
        pictureUrl: "",
        videoUrl: "",
        depth: ""
      },
      //所在区域的省市区
      province: "",
      city: "",
      district: "",
      addr: {
        chooseType: "province",
        province: "",
        city: "",
        district: "",
        //热门城市
        hotList: [
          {
            name: "北京",
            type: "district",
            province: "北京市",
            city: "北京市",
            district: ""
          },
          {
            name: "天津",
            type: "district",
            province: "天津市",
            city: "天津市",
            district: ""
          },
          {
            name: "四川",
            type: "city",
            province: "四川省",
            city: "",
            district: ""
          },
          {
            name: "陕西",
            type: "city",
            province: "陕西省",
            city: "",
            district: ""
          },
          {
            name: "武汉",
            type: "district",
            province: "湖北省",
            city: "武汉市",
            district: ""
          },
          {
            name: "上海",
            type: "district",
            province: "上海市",
            city: "上海市",
            district: ""
          },
          {
            name: "杭州",
            type: "district",
            province: "浙江省",
            city: "杭州市",
            district: ""
          },
          {
            name: "广州",
            type: "district",
            province: "广东省",
            city: "广州市",
            district: ""
          }
        ],
        chooseList: [],
        provinceList: [],
        cityList: [],
        districtList: [],
        // showtoolbar:true,
        isShow: false
      },
      upImgUrlList: [],
      qiniu: this.$$api.mobile.qiniuDownload,
      imgshow_url: "",
      ispart_imgshow: false,
      videoUrl: "",
      //深度集合
      depthList: [],
      //深度显示隐藏
      depthSheetVisible: false,
      //当前深度
      depthValue: "",

      isConfirmAlert: false
    };
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      MessageBox("提示", "系统维护，请联系管理员！");
      this.getProvinceList();
      // this.getdepthList();
    },
    //获取深度code表
    getdepthList() {
      let that = this;
      this.$ajax.get(
        that.$$api.dingCMS.getOpenCodes,
        // "www.iyuhong.com.cn/dingCMS/open/getOpenCodes.do",
        {
          codeType: "GAUGE_HEIGHT",
          open: 1
        },
        res => {
          if (res.status >= 200 && res.status < 300) {
            let data = {
              flex: 1,
              values: [],
              className: "slotDepth"
            };
            data.values = res.data.detailMsg.data.map(item => {
              let obj = {
                text: item.codetext,
                value: item.codevalue
              };
              return obj;
            });

            this.depthList = [data];
            // console.log(obj);
          }
        }
      );
    },
    ondepthListChange(val) {
      if (this.depthList.length) {
        this.depthValue = val.values[0].value;
      }
    },
    depthConfirm() {
      this.form.depth = this.depthValue;
      this.depthSheetVisible = false;
    },
    //提交按钮
    submitBtn() {
      MessageBox("提示", "系统维护，请联系管理员！");
      // let that = this;
      // this.form.province = this.province;
      // this.form.city = this.city;
      // this.form.district = this.district;
      // this.form.pictureUrl = this.upImgUrlList.map(item => item).join(",");
      // this.form.videoUrl = this.videoUrl;
      // if (!this.form.userName) {
      //   Toast({ message: "请填写姓名", duration: 1500 });
      //   return;
      // }
      // if (!this.form.phone) {
      //   Toast({ message: "请填写手机号", duration: 1500 });
      //   return;
      // } else {
      //   if (!this.checkMobile(this.form.phone)) {
      //     Toast({ message: "手机号格式错误", duration: 1500 });
      //     return;
      //   }
      // }
      // if (!this.form.workerName) {
      //   Toast({ message: "请填写工长姓名", duration: 1500 });
      //   return;
      // }
      // if (!this.form.workerPhone) {
      //   Toast({ message: "请选择工长手机号", duration: 1500 });
      //   return;
      // } else {
      //   if (!this.checkMobile(this.form.workerPhone)) {
      //     Toast({ message: "工长手机号格式错误", duration: 1500 });
      //     return;
      //   }
      // }
      // if (!this.form.depth) {
      //   Toast({ message: "请选择深度", duration: 1500 });
      //   return;
      // } else {
      //   if (!this.checkDeth(this.form.depth)) {
      //     Toast({
      //       message: "深度需要在1-10之间，并且只保留一位小数！",
      //       duration: 1500
      //     });
      //     return;
      //   }
      //   // form.depth
      // }
      // if (!this.form.province) {
      //   Toast({ message: "请选择所在区域", duration: 1500 });
      //   return;
      // }
      // if (this.form.workerPhone == this.form.phone) {
      //   Toast({ message: "客户与工长手机号不能相同", duration: 1500 });
      //   return;
      // }
      // Indicator.open();
      // this.$ajax.post(
      //   this.$$api.dingCMS.bishuiapply,
      //   // "www.iyuhong.com.cn/dingCMS/open/bishuiapply.do",
      //   {
      //     cust: JSON.stringify(this.form),
      //     token: "03c470d33cbd8cb8d47204a7afbishui"
      //   },
      //   res => {
      //     if (res.status >= 200 && res.status < 300) {
      //       // debugger
      //       if(res.data.errorcode == 0){
      //           Indicator.close();
      //         // Toast({
      //         //   message: res.data.errmsg,
      //         //   duration: 3000,
      //         //   iconClass: "iconfont icon-duigou"
      //         // });
      //         that.isConfirmAlert = true;
      //         setTimeout(() => {
      //           // location.reload();
      //           that.isConfirmAlert = false;
      //           // 清空数据
      //           that.form.userName = '';
      //           that.form.phone = '';
      //           that.form.workerName = '';
      //           that.form.workerPhone = '';
      //           that.form.depth = '';
      //           that.form.province = '';
      //           that.form.city = '';
      //           that.form.district = '';
      //           that.province = '';
      //           that.city = '';
      //           that.district = '';
      //           that.form.pictureUrl = '';
      //           that.upImgUrlList = [];
      //           that.form.videoUrl = '';
      //           that.videoUrl = '';
      //           that.form.site = '';
      //           that.form.remark = '';
      //         }, 2500);
      //       }else{
      //         Toast({
      //           message: "报单失败，请联系业务管理员",
      //           duration: 1500,
      //           iconClass: "iconfont icon-cuowutishitianchong"
      //           });
      //           Indicator.close();
      //       }
      //     } else {
      //       // Toast({
      //       //   message: res.data.errmsg,
      //       //   duration: 1500
      //       // });
      //       Toast({
      //         message: "提交失败，请联系管理员",
      //         duration: 1500,
      //         iconClass: "iconfont icon-cuowutishitianchong"
      //       });
      //       Indicator.close();
      //     }
      //   }
      // );
    },
    //验证手机号
    checkMobile(sMobile) {
      if (!/^1[3456789]\d{9}$/.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    //验证 深度 1-10 保留一位小数点
    checkDeth(num) {
      if (!/^([1-9](\.\d)?|10)$/.test(num)) {
        return false;
      } else {
        return true;
      }
    },
    //上传视频
    videoChange(e) {
      // console.log(e.target.files[0])
      this.$indicator.open();
      var $that = this;
      var file = e.target.files[0];
      this.imgFile(null, file, function(url) {
        $that.videoUrl = url;
      });
    },
    getUrl(e) {
      var $that = this;
      var file = this.$comm.toBase64(e.base64);
      this.imgFile(null, file, function(url) {
        $that.upImgUrlList.push(url);
      });
      Indicator.close();
    },
    // 上传图片
    imgFile: function(type, file, fun) {
      var $that = this;
      // this.$$api.mobile.getOpenQiniuUpToken
      this.$ajax.get(
        this.$$api.dingCMS.getOpenQiniuUpToken,
        // "http://www.iyuhong.com.cn/dingCMS/open/getOpenQiniuUpToken.do",
        { open: 1 },
        function(res) {
          if (res.status == 200) {
            var token = res.data.token;
            var fileid = res.data.fileid;
            let param = new FormData(); //创建form对象
            param.append("file", file, file.name); //通过append向form对象添加数据
            param.append("chunk", "0"); //添加form表单中其他数据
            param.append("token", token); //添加form表单中其他数据
            param.append("key", fileid); //添加form表单中其他数据
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post($that.$$api.mobile.qiniuUpload, param, config)
              .then(data => {
                var key = data.data.key;
                if (fun) fun(key);
                $that.$indicator.close();
              });
          }
        }
      );
    },
    // 图片预览
    imgShowClick: function(e) {
      var url = e.currentTarget.dataset.src;
      if (url) {
        this.imgshow_url = url;
        this.ispart_imgshow = true;
      }
      // if (e.toElement.src) {
      //   this.imgshow_url = e.toElement.src;
      //   this.ispart_imgshow = true;
      // }
    },
    part_close: function(value) {
      this.ispart_imgshow = value;
    },
    // 删除图片
    delClick: function(index) {
      this.upImgUrlList.splice(index, 1);
    },
    getProvinceList: function() {
      let addr = addressList.default.addressData;
      this.addr.province = this.province || "";
      this.addr.city = this.city || "";
      this.addr.district = this.district || "";
      this.addr.provinceList = addr;
      if (this.province) {
        this.chooseAddress("district");
      } else {
        this.chooseAddress("province");
      }
    },
    // 选择省市区
    addrClick: function() {
      this.addr.isShow = true;
      this.stop();
    },
    chooseAddress: function(type) {
      if (type == "province") {
        this.addr.chooseList = this.addr.provinceList;
        this.addr.province = "";
        this.addr.city = "";
        this.addr.district = "";
        this.addr.cityList = [];
        this.addr.districtList = [];
      } else if (type == "city" && this.addr.province) {
        var provinceList = this.addr.provinceList;
        var cityList = [];
        for (let i = 0, j = provinceList.length; i < j; i++) {
          if (provinceList[i].name == this.addr.province) {
            cityList = provinceList[i].child;
            break;
          }
        }
        this.addr.cityList = cityList;
        this.addr.city = "";
        this.addr.district = "";
        this.addr.districtList = [];
        this.addr.chooseList = cityList;
      } else if (type == "district" && this.addr.province && this.addr.city) {
        var cityList = this.addr.cityList || [];
        if (cityList.length < 1) {
          var provinceList = this.addr.provinceList;
          for (let i = 0, j = provinceList.length; i < j; i++) {
            if (provinceList[i].name == this.addr.province) {
              cityList = provinceList[i].child;
              break;
            }
          }
        }
        var districtList = [];
        for (let ii = 0, jj = cityList.length; ii < jj; ii++) {
          if (cityList[ii].name == this.addr.city) {
            districtList = cityList[ii].child;
            break;
          }
        }
        if (!this.addr.district) {
          this.addr.district = "";
        }
        this.addr.districtList = districtList;
        this.addr.chooseList = districtList;
      }
      this.addr.chooseType = type;
      document.getElementById("subList").scrollTop = 0;
    },
    chooseClick: function(item) {
      var chooseType = this.addr.chooseType;
      if (chooseType == "province") {
        this.addr.province = item.name;
        this.addr.cityList = item.child;
        this.addr.chooseList = item.child;
        this.addr.chooseType = "city";
      } else if (chooseType == "city") {
        this.addr.city = item.name;
        this.addr.districtList = item.child;
        this.addr.chooseList = item.child;
        this.addr.chooseType = "district";
      } else if (chooseType == "district") {
        this.addr.district = item.name;
        this.saveAddrClick();
      }
      document.getElementById("subList").scrollTop = 0;
    },

    hotClick: function(item) {
      this.addr.province = item.province;
      this.addr.city = item.city;
      this.addr.district = item.district;
      this.addr.cityList = [];
      this.addr.districtList = [];
      this.addr.chooseType = item.type;
      this.chooseAddress(item.type);
    },
    saveAddrClick: function(bool) {
      if (!bool) {
        this.province = this.addr.province;
        this.city = this.addr.city;
        this.district = this.addr.district;
      }
      this.addr.isShow = false;
      this.move();
    },
    //禁止滚动
    stop() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    // /取消滑动限制/
    move() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", mo, false);
    }
  },
  watch: {
    /*解决页面层级相互影响滑动的问题*/
    depthSheetVisible: function(val) {
      if (val) {
        document
          .getElementsByTagName("body")[0]
          .addEventListener("touchmove", this.handler, { passive: false });
      } else {
        document
          .getElementsByTagName("body")[0]
          .removeEventListener("touchmove", this.handler, { passive: false });
      }
    }
  }
};
</script>

<style scoped>
#declarationForm-wrapper {
  /* position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden; */
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
.header-wrapper {
  background: linear-gradient(to right, #33485d, #4b7299);
  font-size: 5vw;
}
>>> .mint-field-core {
  font-size: 3.5vw;
}

.form input[type="text"],
.form input[type="number"] {
  text-align: right;
  border: none;
  outline: none;
  font-size: 3.5vw;
}
>>> .mint-cell {
  font-size: 4vw !important;
  margin-bottom: 2vw;
}
footer {
  width: 100%;
  padding: 0 1vw;
  margin-top: 3vh;
  margin-bottom: 1vh;
  box-sizing: border-box;
}
footer >>> .mint-button--normal {
  width: 100%;
}

.item-content {
  width: 65%;
  text-align: right;
  font-size: 3.5vw;
  /*background: blue;*/
  white-space: nowrap;
  text-overflow: ellipsis;
}
/*.model_addr*/
.model_addr {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 22;
  width: 100vw;
  height: 100vh;
}
.model-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 25;
}

.model_addr .model-body {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 30;
  width: 100%;
  height: 65vh;
  background: #fff;
}
.model_addr .model-header {
  height: 6vh;
  padding: 0 5vw;
  border-bottom: 0.5px solid #ccc;
  font-size: 15px;
}
.model_addr .model-hot-title {
  font-size: 12px;
  color: #878787;
  padding: 3vw;
}
.model_addr .model-hot-list {
  padding: 0 5vw;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 14px;
  flex-wrap: wrap;
}
.model_addr .model-hot-group.bg_red {
  color: #fff;
  background: #dc1f31;
}
.model_addr .model-hot-group {
  padding: 2vw 5vw;
  background: #f2f2f2;
  border-radius: 5vw;
  margin-bottom: 2vw;
  margin-right: 3vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-wrap: wrap;
}
.model_addr .model-choose-title {
  border-bottom: 0.5px solid #f2f2f2;
  box-sizing: border-box;
  width: 100%;
  padding: 0 5vw;
  font-size: 14px;
}
.model_addr .model-choose-title div.c_red {
  border-bottom: 1px solid #dc1f31;
  margin-bottom: 1px;
}
.model_addr .model-choose-title div {
  height: 8vw;
  max-width: 30vw;
  margin-right: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.model_addr .model-body,
.model_addr .model-choose {
  display: flex;
  flex-direction: column;
}
.model_addr .model-choose {
  flex: 1;
  overflow: auto;
}
.model_addr .model-choose-list {
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  /*height: calc( 100% - 30vh);*/
  /*height: 38vh;*/
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}
.model_addr .model-choose-group {
  padding: 3vw 5vw;
  text-align: left;
}
.item-value {
  color: #888;
}
>>> .mint-header-title {
  overflow: initial;
}
>>> input.file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 15;
  opacity: 0;
}
.procedure {
  background: #fff;
  padding: 4vw;
  margin-bottom: 2vw;
}
.procedure-img {
  width: 22vw;
  height: 22vw;
  margin-right: 3.226vw;
  display: inline-block;
  box-sizing: border-box;
  border: 1px solid #ccc;
}
.uploadVideo-content {
  width: 100%;
  padding: 4vw;
  box-sizing: border-box;
  background: #fff;
  margin-bottom: 2vw;
}
.sample-content {
  width: 100%;
  display: flex;
  box-sizing: border-box;
  background: #fff;
  margin-bottom: 2vw;
}
.upVideo-wrapper {
  width: 22vw;
  height: 22vw;
  margin-right: 3.226vw;
  display: inline-block;
  box-sizing: border-box;
  border: 1px solid #ccc;
  position: relative;
}
.upVideo-wrapper img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 5vw;
  box-sizing: border-box;
}
.upVideo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 15;
  opacity: 0;
}
.depth-picker-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 5vw;
  padding: 3vw;
  box-sizing: border-box;
}

/* .sample-wrapper {
  width: 22vw;
  height: 22vw;
  margin-right: 3.226vw;
  display: inline-block;
  box-sizing: border-box;
  border: 1px solid #ccc;
  position: relative;
} */
.sample-wrapper {
  /* width: 30.9vw; */
  /* height: 22vw; */
  display: inline-block;
  box-sizing: border-box;
  /* border: 1px solid #ccc; */
  position: relative;
}

.sample-wrapper img {
  /* position: absolute; */
  /* top: 0; */
  /* left: 0; */
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.sample-content > div {
  padding: 2vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
}

.banner {
  width: 100%;
}
.banner img {
  width: 100%;
}
.form {
  width: 90vw;
  z-index: 10;
  position: relative;
  margin: auto;
  top: -20px;
  border-radius: 10px;
  padding: 10px 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  box-sizing: border-box;
}
.form_group:not(:last-child) {
  border-bottom: 1px solid #ccc;
}
.form_group .icon .c_icon {
  font-size: 40px;
}
.form-icon img {
  width: 13px;
}

/*.confirmAlert*/
.confirmAlert {
  position: fixed;
  top: 25vh;
  left: 15vw;
  height: 310px;
  width: 70vw;
  background: #fff;
  z-index: 200;
  border: 2px solid #1c4be8;
  border-radius: 15px;
  overflow: hidden;
}
.confirmAlertBg {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 190;
}

.confirmAlert .close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 16px;
  height: 16px;
  z-index: 201;
}
.c-img {
  width: 100%;
}
.confirmAlert .bg img {
  width: 50px;
}
.confirmAlert .bg {
  background: #1c4be8;
  width: 110%;
  height: 92px;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-3.5vw);
}
.c_size_16 {
  font-size: 16px;
}
.c_size_20 {
  font-size: 20px;
}
.c_size_24 {
  font-size: 24px;
}
.c_m_t_5 {
  margin-top: 5px;
}
.c_bold {
  font-weight: bold;
}

.confirmAlert .btn .back {
  background: #1c4be8;
  color: #fff;
  border-radius: 20px;
  font-size: 20px;
  display: inline-block;
  margin-top: 35px;
  width: 50vw;
  height: 45px;
  line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/declarationForm.vue